{
  "appName": "Employee Management Platform",
  "actions": {
    "save": "Save",
    "saving": "Saving…",
    "cancel": "Cancel",
    "delete": "Delete",
    "deleting": "Deleting…",
    "edit": "Edit",
    "create": "Create",
    "retry": "Retry",
    "refresh": "Refresh",
    "export": "Export",
    "dismiss": "Dismiss",
    "done": "Done",
    "restore": "Restore",
    "restoring": "Restoring…",
    "signOut": "Sign out",
    "changePassword": "Change password",
    "activate": "Activate",
    "activating": "Activating…",
    "deactivate": "Deactivate",
    "deactivating": "Deactivating…",
    "copy": "Copy",
    "upload": "Upload",
    "uploading": "Uploading…",
    "approve": "Approve",
    "approving": "Approving…",
    "reject": "Reject",
    "rejecting": "Rejecting…",
    "openMenu": "Open menu",
    "closeMenu": "Close menu",
    "openUserMenu": "Open user menu",
    "language": "Language",
    "selectLanguage": "Select language",
    "selectAll": "Select all",
    "close": "Close",
    "backToHome": "Home"
  },
  "aria": {
    "loadingApplication": "Loading application",
    "loading": "Loading…",
    "searchEmployees": "Search employees"
  },
  "pagination": {
    "previous": "Previous",
    "next": "Next",
    "pageOf": "Page {{current}} of {{total}}",
    "records": "Records:",
    "previousPage": "Previous page",
    "nextPage": "Next page"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive",
    "deleted": "Deleted"
  },
  "table": {
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "actions": "Actions",
    "email": "Email",
    "role": "Role",
    "date": "Date",
    "note": "Note",
    "noData": "No data",
    "failedToLoad": "Failed to load",
    "created": "Created"
  },
  "filters": {
    "from": "From",
    "to": "To",
    "search": "Search...",
    "clearFilters": "Clear filters",
    "allEmployees": "All employees",
    "employee": "Employee",
    "timeRange": "Time range"
  },
  "form": {
    "optional": "(optional)",
    "unassigned": "(Unassigned)",
    "active": "Active"
  },
  "errors": {
    "unexpectedError": "An unexpected error occurred. Please try again.",
    "saveFailed": "Save failed",
    "loadFailed": "Failed to load data. Please try again.",
    "connectionError": "Check your connection and try again."
  },
  "nav": {
    "mainNavigation": "Main navigation",
    "platformNavigation": "Platform navigation"
  }
}
